export const PENDING_EMAIL_SIGN_IN_KEY = 'pendingEmailSignIn';
let generation = 0;
export const getEmailSignInGeneration = () => generation;

export const clearPendingEmailSignIn = (challengeId) => {
  if (challengeId && readPendingEmailSignIn()?.challengeId !== challengeId) return;
  ++generation;
  try { sessionStorage.removeItem(PENDING_EMAIL_SIGN_IN_KEY); } catch (_) { /* storage may be disabled */ }
};

export const readPendingEmailSignIn = () => {
  try {
    const value = JSON.parse(sessionStorage.getItem(PENDING_EMAIL_SIGN_IN_KEY));
    const expiresAt = Date.parse(value?.expiresAt);
    const resendAt = Date.parse(value?.resendAt);
    if (value?.version === 1 && typeof value.email === 'string' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.email) &&
      value.email === value.email.trim().toLowerCase() && typeof value.challengeId === 'string' &&
      value.challengeId.length > 0 && value.challengeId.length <= 512 &&
      Number.isFinite(expiresAt) && Number.isFinite(resendAt) && resendAt < expiresAt) {
      return { email: value.email, challengeId: value.challengeId, expiresAt: value.expiresAt, resendAt: value.resendAt };
    }
  } catch (_) { /* a malformed/stale browser record is not an authentication result */ }
  try { sessionStorage.removeItem(PENDING_EMAIL_SIGN_IN_KEY); } catch (_) { /* storage may be disabled */ }
  return null;
};

export const savePendingEmailSignIn = ({ email, challengeId, expiresAt, resendAt }) => {
  // Explicit fields keep codes and Firebase credentials out of browser storage.
  try {
    sessionStorage.setItem(PENDING_EMAIL_SIGN_IN_KEY, JSON.stringify({ version: 1, email, challengeId, expiresAt, resendAt }));
    return true;
  } catch (_) { return false; }
};
